import { useContext } from 'react'
import { SearchContext } from '../context'

export function useSearch() {
  return useContext(SearchContext)
}
